import React from 'react'
// isomorphic-dompurify is DOMPurify in the browser and DOMPurify on jsdom on the server, so blocks
// that render HTML also work with server-side rendering (plain DOMPurify has no sanitize() without a DOM)
import DOMPurify from 'isomorphic-dompurify'

const sanitize = iframe =>
    DOMPurify.sanitize(iframe, {
        ALLOWED_TAGS: ['iframe', 'div'],
        ALLOWED_ATTR: [
            'id',
            'class',
            'className',
            'src',
            'style',
            'frameborder',
            'gesture',
            'allow',
            'allowfullscreen',
            'width',
            'height',
        ],
    })

export { sanitize }

export default ({ content, ...other }) => (
    <div {...other} dangerouslySetInnerHTML={{ __html: sanitize(content) }}></div>
)
